<template>
  <div class="search-warp">
    <el-form :model="editField" label-width="100px" ref="addForm" :inline="true" class="demo-form-inline">
        <el-form-item v-for="(item,index) in querymodule" :key="index" v-if="item.type == 'dropdownfields'" :label="item.aliasname">
            <el-select v-model="dropdownmode[item.fieldname]" clearable placeholder="请选择" style="width:120px">
                <el-option
                    v-for="(options,index2) in item.options"
                    :key="index2"
                    :label="options.label"
                    :value="options.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item v-for="(item,index) in querymodule" :key="index" v-if="item.type == 'datefields'" :label="item.aliasname">
            <el-date-picker
                width="120px"
                v-model="timemode"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
        </el-form-item>
        <el-form-item v-for="(item,index) in querymodule" :key="index" v-if="item.type == 'regionfields'" :label="item.aliasname">
            <el-input v-model="regionmode[item.fieldname+'$'+'minvalue']" placeholder="" style="width:52px"></el-input><span style="color:#666;margin-left: 5px">-</span>
            <el-input v-model="regionmode[item.fieldname+'$'+'maxvalue']" placeholder="" style="width:52px"></el-input>
        </el-form-item>
        <el-form-item label="关键字">
            <el-input v-model="queryParams.wherekey" clearable placeholder="请输入内容" style="width:200px"></el-input>
        </el-form-item>
    </el-form>
    <div class="clear">
        <div class="fl"  style="color:#999;font-size:12px;padding-left:10px;">{{keylist}}</div>
        <div class="fr">
            <input type="button" name="" class="operate-btn" id="" value="查询"  @click="clickBtn()"/>
            <input type="button" name="" class="operate-btn" value="录入" @click="entryClick()" v-if="nowSelectModule.funcname != '法律法规文件管理'&&nowSelectModule.funcname != '消息管理'"/>
            <input type="button" name="" class="operate-btn" value="删除" @click="deleteClick()"/>
            <input type="button" name="" class="operate-btn" value="上传" @click="uploadClick()" v-if="nowSelectModule.funcname == '法律法规文件管理'"/>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState , mapMutations} from 'vuex'
import {getTablequeryinfo} from '@/apis/api'
export default {
    props: ['dataOption','enterPosition'],
    data() {
        return {
            editField:{},
            querymodule:[],    //查询的数据模型
            queryParams:{
                resourceid:'',
                sortfield:'',
                sortkey:'DESC',
                wherekey:'',      //关键字
                page:1,          //当前页
                size:10,          //每页条数
                stime:'',         //开始时间
                etime:'',         //结束时间
                wherejson:'',     //下拉查询
                rangejson:'',     //范围查询
                timefield:'',     //时间字段
                isdataflow:'0',
                unitcode:'',
                regioncode:'',
                authoritytable:'0'
            },
            timemode:[],       //时间条件模型
            dropdownmode:{},   //下拉条件模型
            regionmode:{},     //范围条件模型
            regionmodeArr:{},
            keylist:'关键字范围：',        //所包含的关键字
            allfields:null,          //所有字段信息
        }
    },
    methods:{
        ...mapMutations([
            'CHANGEDATAUUID',
            'CHANGEDATAOPERATETYPE',
            'CHANGEMAINDATAOPERATETYPE'
        ]),
        //字段数据请求
        queryFields(){
            var params = {
                resourceid : this.dataOption.resourceid,
                userid : this.userInfo.uuid,
                isdataflow : '0',
                menuid : ''
            }
            getTablequeryinfo(params).then((res) => {
//          	console.log(res,115)
                if(res.code == '1') {
//              	console.log(res.result,123)
                    this.allfields = res.result.allfields;
                    this.initQuerymodule(res.result);
                }else {
//                  this.$message({
//                      message: res.message || '服务请求失败！',
//                      type: 'warning'
//                  });
                }
            }).catch((err) => {
//              console.log(err);
                this.$message({
                    message: '服务请求失败！',
                    type: 'warning'
                });
            })
        },
        //初始化查询列表的数据模型
        initQuerymodule(data) {
            var _this = this;

            this.dropdownmode = {};
            this.keylist = '关键字范围：';
            this.regionmodeArr = [];
            this.querymodule = [];
            this.queryParams.wherekey=''


            var transfield = data.transfield ? data.transfield : {};

            for(var i = 0 , ilen = data.allfields.length ; i < ilen ; i++) {
                if(data.allfields[i].allindextype == 1) {
                    this.keylist += (data.allfields[i].aliasname+'、')
                }
                //下拉框
                if(!this.isEmptyObject(data.dropdownfields)) {
                    $.each(data.dropdownfields, function (n, item) {
                        if(data.allfields[i].fieldname == n) {
                            if(item) {
                                var arrStr = item.split(','),
                                    arrOpt = [];
                                if(transfield.hasOwnProperty(n)) {
                                    for(var j = 0 , jlen = arrStr.length ; j < jlen ; j++ ) {
                                        arrOpt.push({value:arrStr[j] , label:transfield[n][arrStr[j]] ? transfield[n][arrStr[j]] : arrStr[j]})
                                    }
                                }else {
                                    for(var j = 0 , jlen = arrStr.length ; j < jlen ; j++ ) {
                                        arrOpt.push({value:arrStr[j] , label:arrStr[j]})
                                    }
                                }
                                _this.querymodule.push({fieldname:data.allfields[i].fieldname,aliasname:data.allfields[i].aliasname,type:'dropdownfields',options:arrOpt})
                            }else {
                                _this.querymodule.push({fieldname:data.allfields[i].fieldname,aliasname:data.allfields[i].aliasname,type:'dropdownfields',options:[]})
                            }

                        }
                    });
                }
                //日期
                if(data.datefields) {
                    var dateArr = data.datefields.split(',');
                    if(data.allfields[i].fieldname == dateArr[dateArr.length - 1]) {

                        _this.queryParams.timefield = data.allfields[i].fieldname;
                        _this.querymodule.push({fieldname:data.allfields[i].fieldname,aliasname:data.allfields[i].aliasname,type:'datefields'})
                    }
                }
                //范围
                if(!this.isEmptyObject(data.regionfields)) {
                    var regionfields = data.regionfields.split(",");
                    for (var j = 0; j < regionfields.length; j++) {
                        if(data.allfields[i].fieldname == regionfields[j]) {
                            _this.regionmodeArr.push({"fieldname":data.allfields[i].fieldname,"minvalue":"","maxvalue":""})
                            _this.querymodule.push({fieldname:data.allfields[i].fieldname,aliasname:data.allfields[i].aliasname,type:'regionfields'})
                        }
                    }
                }
            }

            //设置跳转过来的界面的默认条件
            if(this.$route.query.dropdownmode) {
                this.dropdownmode = this.$route.query.dropdownmode
                // Object.assign(this.dropdownmode , this.$route.query.dropdownmode)
            }else {
                this.dropdownmode = {};
            }

        },
        clickBtn() {
            Object.assign(this.queryParams , {resourceid:this.dataOption.resourceid});
            this.$bus.$emit('querydata',{allfields:this.allfields,queryParams:this.queryParams});
        },
        entryClick() {
            var uuid = this.guid();
            this.CHANGEDATAUUID(uuid);
            this.CHANGEDATAOPERATETYPE(0);
            if(this.enterPosition == "tab-list") {
                this.$router.push({path:'main/have/tabdetail',name:'tabdetail',params:{uuid:''}});
                this.CHANGEMAINDATAOPERATETYPE(0);
            }else if(this.enterPosition == "form-list") {
                this.$router.push({path:'main/have/formdetail',name:'formdetail',params:{uuid:''}});
            }else {
                window.location.hash = "#aaa";
            }
        },
        deleteClick() {
            this.$bus.$emit('deletedata',{});
        },
        uploadClick() {
            this.$bus.$emit('uploadfiles',{});
        },
        getCompHeight() {
            return $('.search-warp').outerHeight();
        },
        //---------- 工具方法  ----------
        //生成随机数
        guid() {
            function S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            }
            return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
        },
        //判断对象是否为空
        isEmptyObject: function (e) {
            var t;
            for (t in e)
                return !1;
            return !0
        },
    },
    computed: {
        ...mapState([
            'userInfo',
            'nowSelectModule'
        ]),

    },
    created() {

    } ,
    watch:{
        dataOption: {
            handler:function(val,oldval){
                this.queryFields();
            },
            deep:true
        },
        timemode: {
            handler:function(val,oldval){
                this.queryParams.stime = val[0];
                this.queryParams.etime = val[1];
            },
            deep:true
        },
        dropdownmode: {
            handler:function(val,oldval){
                for(var key in val) {
                    if(val[key] == '') {
                        this.$delete(val,key);
                    }
                }
                this.queryParams.wherejson = JSON.stringify(val);
//              console.log(this.queryParams)
            },
            deep:true
        },
        regionmode : {
             handler:function(val,oldval){
                var _this = this;
                $.each(val,function (key,value){
                    var fieldname = key.split('$')[0];
                    var valuename = key.split('$')[1];
                    for(var i = 0 , ilen = _this.regionmodeArr.length ; i < ilen ; i++) {
                        if(_this.regionmodeArr[i].fieldname == fieldname) {
                            _this.regionmodeArr[i][valuename] = value;
                        }
                    }
                });
                _this.queryParams.rangejson = JSON.stringify(_this.regionmodeArr);
            },
            deep:true
        }
    },
    mounted(){
        this.queryFields();
    },
    beforeDestroy (){
        this.$bus.$off('querydata');
        this.$bus.$off('deletedata');
    }
}
</script>

<style lang="less" scoped>
    .search-warp {
        width: 98%;
        margin: 0 auto;
        box-shadow: 0 0 5px #eee;
        background-color: #fff;
        padding: 10px 0;
    }
    .operate-btn {
        border: none;
        height: 30px;
        padding-left: 16px;
        padding-right: 16px;
        background-color: #398de5;
        color: #fff;
        margin-right: 15px;
        font-size: 14px;
        border-radius: 3px;
        &:hover {
            background-color: #398de5;
        }
    }
    .el-form-item {
        margin-bottom: 10px;
    }
    .el-form-item__label {
        line-height: 16px;
        // vertical-align: middle;
    }
</style>



// WEBPACK FOOTER //
// src/sysmodule/tab/searchpart.vue